// 日本語 language package
export default {
  // 共通
  'common.confirm': '確認',
  'common.cancel': '取消',
  'common.submit': '提出',
  'common.save': '保存',
  'common.delete': '削除',
  'common.edit': '編集',
  'common.back': '戻る',
  'common.loading': '読み込み中...',
  'common.noData': 'データなし',
  'common.success': '成功',
  'common.error': 'エラー',
  'common.retry': '再試行',
  'common.more': 'もっと見る',
  'common.language': '言語',
  'common.loginRequired': 'ログインしてください',
  'common.networkError': 'ネットワークエラー、後でもう一度お試しください',
  'common.loginRequired': 'ログインしてください',
  'common.networkError': 'ネットワークエラー、後でもう一度お試しください',
  
  // ログインページ
  'login.title': 'ログイン',
  'login.register': '登録',
  'login.username': 'ユーザー名',
  'login.password': 'パスワード',
  'login.loginBtn': 'ログイン',
  'login.registerBtn': '登録',
  'login.forgotPassword': '忘れた？',
  'login.passwordLogin': 'パスワードでログイン',
  'login.passwordRegister': 'パスワードで登録',
  'login.loginHint': '電話とパスワード入力',
  'login.registerHint': '電話とパスワードで登録',
  'login.phonePlaceholder': '電話番号',
  'login.passwordPlaceholder': 'パスワード',
  'login.loggingIn': 'ログイン中...',
  'login.registering': '登録中...',
  'login.hasAccount': 'アカウントあり？',
  'login.noAccount': 'アカウントなし？',
  'login.goLogin': 'ログイン',
  'login.goRegister': '登録',
  'login.loginAgreement': 'ログインで利用規約に同意',
  'login.registerAgreement': '登録で利用規約に同意',
  'login.contactService': 'サポート：{tel}',
  'login.phoneRequired': '電話番号必須',
  'login.phoneInvalid': '無効な電話番号',
  'login.passwordRequired': 'パスワード必須',
  'login.passwordMinLength': '6文字以上',
  'login.loginSuccess': 'ログイン成功',
  'login.registerSuccess': '登録成功',
  'login.loginFailed': 'ログイン失敗',
  'login.registerFailed': '登録失敗',
  'login.networkError': 'ネットワークエラー',
  'login.codeSent': 'コード送信済み',
  'login.sendCodeFailed': 'コード送信失敗',
  'login.codeRequired': 'コード必須',
  'login.codeLogin': 'コードログイン',
  'login.codeLoginHint': '電話とコード入力',
  'login.codePlaceholder': '認証コード',
  'login.sending': '送信中...',
  'login.sendCode': 'コード送信',
  'login.usePassword': 'パスワード使用',
  'login.goPassword': 'パスワード',
  'login.goCode': 'コード',
  'login.areaCode.china': '+86',
  'login.areaCode.usa': '+1',
  'login.areaCode.uk': '+44',
  'login.areaCode.india': '+91',
  'login.areaCode.singapore': '+65',
  'login.areaCode.hongkong': '+852',
  'login.areaCode.taiwan': '+886',
  'login.areaCode.japan': '+81',
  'login.areaCode.korea': '+82',
  'login.areaCode.malaysia': '+60',
  'login.areaCode.thailand': '+66',
  'login.areaCode.vietnam': '+84',
  'login.areaCode.indonesia': '+62',
  'login.areaCode.philippines': '+63',
  'login.areaCode.russia': '+7',
  'login.areaCode.germany': '+49',
  'login.areaCode.france': '+33',
  'login.areaCode.italy': '+39',
  'login.areaCode.spain': '+34',
  'login.areaCode.netherlands': '+31',
  'login.areaCode.sweden': '+46',
  'login.areaCode.norway': '+47',
  'login.areaCode.denmark': '+45',
  'login.areaCode.brazil': '+55',
  'login.areaCode.mexico': '+52',
  'login.areaCode.australia': '+61',
  'login.areaCode.newzealand': '+64',
  'login.areaCode.saudiarabia': '+966',
  'login.areaCode.uae': '+971',
  'login.areaCode.qatar': '+974',
  'login.areaCode.kuwait': '+965',
  'login.areaCode.bahrain': '+973',
  'login.areaCode.oman': '+968',
  'country.china': '中国',
  'country.usa': 'アメリカ',
  'country.uk': 'イギリス',
  'country.india': 'インド',
  'country.singapore': 'シンガポール',
  'country.hongkong': '香港',
  'country.taiwan': '台湾',
  'country.japan': '日本',
  'country.korea': '韓国',
  'country.malaysia': 'マレーシア',
  'country.thailand': 'タイ',
  'country.vietnam': 'ベトナム',
  'country.indonesia': 'インドネシア',
  'country.philippines': 'フィリピン',
  'country.russia': 'ロシア',
  'country.germany': 'ドイツ',
  'country.france': 'フランス',
  'country.italy': 'イタリア',
  'country.spain': 'スペイン',
  'country.netherlands': 'オランダ',
  'country.sweden': 'スウェーデン',
  'country.norway': 'ノルウェー',
  'country.denmark': 'デンマーク',
  'country.brazil': 'ブラジル',
  'country.mexico': 'メキシコ',
  'country.australia': 'オーストラリア',
  'country.newzealand': 'ニュージーランド',
  'country.saudiarabia': 'サウジアラビア',
  'country.uae': 'UAE',
  'country.qatar': 'カタール',
  'country.kuwait': 'クウェート',
  'country.bahrain': 'バーレーン',
  'country.oman': 'オマーン',
  
  // ホームページ
  'home.welcome': 'ようこそ',
  'home.title': 'ホーム',
  'home.pageTitle': 'ホーム',
  'home.loginRequired': 'ログインが必要',
  'home.orderHistory': '注文履歴',
  'home.customerService': 'サポート',
  'home.logoutSuccess': 'ログアウト成功',
  'home.greeting': '{name}さん',
  'home.defaultDriver': 'ドライバー',
  'home.onlineStatus': 'オンライン',
  'home.completedOrders': '今日完了',
  'home.todayIncome': '今日の収入',
  'home.pendingOrders': '処理待ち',
  'home.quickFunctions': 'ショートカット',
  'home.selectService': 'サービス選択',
  'home.orderHall': '注文ホール',
  'home.realTimeOrders': 'リアルタイム注文',
  'home.phoneOrders': '電話注文',
  'home.appointmentManagement': '予約管理',
  'home.myWallet': 'ウォレット',
  'home.incomeWithdraw': '収入・出金',
  'home.orderRecords': '注文記録',
  'home.recordManagement': '注文管理',
  'home.contactService': 'サポート：{tel}',
  
  // 注文カード
  'orderCard.status.cancelled': 'キャンセル',
  'orderCard.status.calling': '呼出中',
  'orderCard.status.pickingUp': '迎車中',
  'orderCard.status.arrivedPickup': '到着',
  'orderCard.status.passengerBoarded': '乗車済',
  'orderCard.status.completed': '完了',
  'orderCard.status.driverCollected': '集金済',
  'orderCard.status.unknown': '不明',
  
  'orderCard.payment.paid': '支払済',
  'orderCard.payment.unpaid': '未払い',
  
  'orderCard.label.departureTime': '時間',
  'orderCard.label.flightInfo': '便名',
  'orderCard.label.departure': '出発地',
  'orderCard.label.destination': '目的地',
  'orderCard.label.phone': '電話',
  'orderCard.label.remark': '備考',
  'orderCard.label.amount': '金額',
  'orderCard.label.paymentStatus': '支払',
  
  'orderCard.remark.adults': '大人{count}名',
  'orderCard.remark.children': '子供{count}名',
  'orderCard.remark.childSeats': 'チャイルドシート{count}',
  'orderCard.remark.luggage': '荷物{count}個',
  
  'orderCard.action.grabOrder': '受注',
  'orderCard.action.contactPassenger': '連絡',
  'orderCard.action.arrivedPickup': '到着',
  'orderCard.action.passengerBoarded': '乗車済',
  'orderCard.action.orderEnd': '終了',
  
  // 空港送迎 - 共通
  'airportTransfer.error.fetchFailed': '取得失敗',
  'airportTransfer.error.unknown': '不明なエラー',
  
  // 空港送迎 - リスト
  'airportTransfer.list.loadingMore': '読込中...',
  'airportTransfer.list.noMore': 'データなし',
  
  // 空港送迎 - 更新
  'airportTransfer.pull.activate': '離して更新',
  'airportTransfer.pull.deactivate': '引いて更新',
  'airportTransfer.pull.release': '読込中...',
  'airportTransfer.pull.finish': '更新完了',
  
  // 空港送迎 - インデックス
  'airportTransfer.index.title': '空港送迎',
  'airportTransfer.index.subtitle': '簡単に稼ぐ',
  'airportTransfer.index.hallTitle': '注文ホール',
  'airportTransfer.index.hallDesc': '注文を確認・受注',
  'airportTransfer.index.recordTitle': '注文記録',
  'airportTransfer.index.recordDesc': '注文管理・更新',
  'airportTransfer.index.tips': 'ヒント：状態を更新して',
  
  // 空港送迎 - 注文ホール
  'airportTransfer.hall.grabbing': '受注中...',
  'airportTransfer.hall.grabSuccess': '受注成功',
  'airportTransfer.hall.grabFailed': '受注失敗',
  'airportTransfer.hall.grabError': 'エラー、再試行',
  'airportTransfer.hall.emptyText': '注文なし',
  'airportTransfer.hall.emptyTips': 'リアルタイム更新中',
  
  // 空港送迎 - 注文記録
  'airportTransfer.record.update': '更新',
  'airportTransfer.record.processing': '処理中...',
  'airportTransfer.record.updateFailed': '更新失敗',
  'airportTransfer.record.updateError': 'エラー、再試行',
  'airportTransfer.record.emptyText': '記録なし',
  'airportTransfer.record.emptyTips': '注文を受注しよう',

  // チャットページ
  'chat.title': '***{passengerPhoneSuffix}と会話',
  'chat.close': '閉じる',
  'chat.loadingMore': '読込中...',
  'chat.inputPlaceholder': 'メッセージ...',
  'chat.send': '送信',
  'chat.endedTip': '会話終了',
  'chat.unread': '未読',
  'chat.sending': '⏳',
  'chat.failed': '×',
  'chat.sendFailed': '送信失敗',
  'chat.networkError': 'ネットワークエラー',
  'chat.uploadFailed': 'アップロード失敗',
  'chat.loadFailed': '読込失敗',

  // メッセージセンター
  'messageCenter.title': 'メッセージ',
  'messageCenter.loginRequired': 'ログインが必要',
  'messageCenter.fetchFailed': '取得失敗',
  'messageCenter.networkError': 'ネットワークエラー',
  'messageCenter.noMessages': 'メッセージなし',
  'messageCenter.loading': '読込中...',
  'messageCenter.loadMore': 'もっと読込',
  'messageCenter.orderType.express': '速達',
  'messageCenter.orderType.carpool': '相乗り',
  'messageCenter.orderType.airport': '空港送迎',
  'messageCenter.orderType.unknown': '不明',
  'messageCenter.time.justNow': '今',
  'messageCenter.time.minutesAgo': '{count}分前',
  'messageCenter.time.hoursAgo': '{count}時間前',
  'messageCenter.imageMessage': '[画像]',

  // ウォレットページ
  'wallet.pageTitle': 'ウォレット',
  'wallet.accountBalance': '残高',
  'wallet.fullTimeDriver': '正社員',
  'wallet.availableBalance': '出金可能',
  'wallet.frozenBalance': '凍結中',
  'wallet.nextFreeBalance': '次回解凍',
  'wallet.withdraw': '出金',
  'wallet.withdrawBtn': '出金',
  'wallet.billDetails': '明細',
  'wallet.income': '収入',
  'wallet.expenditure': '支出',
  'wallet.noIncomeRecords': '収入なし',
  'wallet.noExpenditureRecords': '支出なし',
  'wallet.loadMore': 'もっと',
  'wallet.loading': '読込中...',
  'wallet.refreshActivate': '離して更新',
  'wallet.refreshDeactivate': '引いて更新',
  'wallet.refreshRelease': '読込中...',
  'wallet.refreshFinish': '更新完了',
  'wallet.withdrawModalTitle': '出金',
  'wallet.withdrawAmountPlaceholder': '金額',
  'wallet.availableAmountLabel': '出金可能：',
  'wallet.alipayAccountPlaceholder': 'Alipay（メール/電話）',
  'wallet.realNamePlaceholder': '本名',
  'wallet.cancel': '取消',
  'wallet.confirmWithdraw': '確認',
  'wallet.withdrawing': '処理中...',
  'wallet.withdrawSuccess': '申請完了',
  'wallet.withdrawFailed': '失敗',
  'wallet.amountRequired': '金額を入力',
  'wallet.amountMin': '最低1元',
  'wallet.amountExceed': '残高超過',
  'wallet.accountRequired': 'Alipay必須',
  'wallet.accountInvalid': '無効なAlipay',
  'wallet.nameRequired': '名前必須',
  'wallet.nameMin': '2文字以上',
  'wallet.nameMax': '20文字以下',
  'wallet.nameInvalid': '無効な名前',
  'wallet.amountValid': '有効',
  'wallet.accountValid': '有効',
  'wallet.nameValid': '有効',
  'wallet.noWithdrawableBalance': '出金残高なし',
  'wallet.loginExpired': 'セッション切れ',
  'wallet.getBalanceFailed': '残高取得失敗',
  'wallet.getBillsFailed': '明細取得失敗',
  'wallet.refreshFailed': '更新失敗',
  'wallet.networkError': 'ネットワークエラー',
  'wallet.unknownError': '不明なエラー',
  'wallet.receivedFare': '運賃受領',
  'wallet.refund': '返金',
  'wallet.withdrawToAlipay': 'Alipayへ',
  'wallet.receivedReward': '報酬受領',
  'wallet.other': 'その他',

  // 電話注文ページ
  'callOrder.tab.pending': '待機中',
  'callOrder.tab.finished': '完了',
  'callOrder.dateFilter.all': '全て',
  'callOrder.dateFilter.today': '今日',
  'callOrder.dateFilter.tomorrow': '明日',
  'callOrder.dateFilter.recent3': '3日間',
  'callOrder.dateFilter.more': 'もっと',
  'callOrder.empty': '注文なし',
  'callOrder.label.amount': '金額',
  'callOrder.action.contactPassenger': '連絡',
  'callOrder.action.playVoice': '再生',
  'callOrder.message.processing': '処理中...',
  'callOrder.message.updateSuccess': '更新完了',
  'callOrder.message.updateFailed': '更新失敗',
  'callOrder.message.updateError': 'エラー、再試行',
  'callOrder.voice.playFailed': '再生失敗',
  'callOrder.voice.noVoice': '音声なし',
  'callOrder.action.arrivedPickup': '到着',
  'callOrder.action.passengerBoarded': '乗車済',
  'callOrder.action.orderEnd': '終了',
  'callOrder.action.update': '更新',
  'callOrder.label.flight': '便名',
  'callOrder.label.phone': '電話',
  'callOrder.detail.loading': '読込中...',
  'callOrder.detail.orderNotFound': '見つかりません',
  'callOrder.detail.fetchFailed': '取得失敗',
  'callOrder.detail.orderInfoMissing': '情報なし',
  'callOrder.detail.noPickupInfo': '乗車地なし',
  'callOrder.detail.noDestinationInfo': '目的地なし',
  'callOrder.detail.voicePlayFailed': '再生失敗',
  'callOrder.detail.noVoiceInfo': '音声なし',
  'callOrder.detail.processing': '処理中...',
  'callOrder.detail.operationSuccess': '完了',
  'callOrder.detail.updateFailed': '更新失敗',
  'callOrder.detail.updateError': 'エラー、再試行',
  'callOrder.detail.invalidFeeAmount': '無効な金額',
  'callOrder.detail.confirmNoCash': '現金なし、オンライン請求？',
  'callOrder.detail.paymentInitiated': '請求送信済',
  'callOrder.detail.submitFailed': '送信失敗',
  'callOrder.detail.submitError': 'エラー、再試行',
  'callOrder.detail.confirmCashReceived': '現金受領？',
  'callOrder.detail.orderCompleted': '完了',
  'callOrder.detail.orderIdCopied': 'IDコピー済',
  'callOrder.detail.confirm': '確認',
  'callOrder.detail.cancel': '取消',
  'callOrder.detail.arrivedPickupConfirm': '乗車地到着？',
  'callOrder.detail.passengerBoardedConfirm': '乗車、開始？',
  'callOrder.detail.hint': 'ヒント',
  'callOrder.detail.navigation': 'ナビ',
  'callOrder.detail.contactPassenger': '連絡',
  'callOrder.detail.replayVoice': '再生',
  'callOrder.detail.slideArrivePickup': 'スライド：到着',
  'callOrder.detail.slidePassengerBoarded': 'スライド：乗車',
  'callOrder.detail.slideEndTrip': 'スライド：終了',
  'callOrder.detail.slideOperation': 'スライド',
  'callOrder.detail.operationSuccessful': '完了',
  'callOrder.detail.mapLoading': '地図読込中...',
  'callOrder.detail.mapLoadingHint': 'ネットワーク確認',
  'callOrder.detail.mapLoadFailed': '地図失敗',
  'callOrder.detail.startPoint': '起点',
  'callOrder.detail.endPoint': '目的地',
  'callOrder.detail.paymentWarning': '損失を避けるため、車内で支払いを',
  'callOrder.detail.fee': '運賃',
  'callOrder.detail.enterFee': '運賃入力',
  'callOrder.detail.yuan': '元',
  'callOrder.detail.feeConfirmationNote': '確認後変更不可',
  'callOrder.detail.noCashPayment': '現金なし、オンライン請求',
  'callOrder.detail.cashReceived': '現金受領',
  'callOrder.detail.orderNumber': 'ID：',
  'callOrder.detail.copy': 'コピー',
  'callOrder.detail.completed': '完了',

  // 無料カード
  'freeCard.title': '無料カード',
  'freeCard.detailTitle': 'カード詳細',
  'freeCard.myTitle': '購入済み',
  'freeCard.todayReward': '本日の報酬',
  'freeCard.viewPurchased': '購入済み表示',
  'freeCard.buyModal.title': 'カード購入',
  'freeCard.buyModal.walletPay': 'ウォレット支払い',
  'freeCard.buyModal.walletBalance': '（残高：{balance}元）',
  'freeCard.buyModal.insufficientBalance': '残高不足。稼いでから購入してください',
  'freeCard.buyModal.buyNow': '今すぐ購入',
  'freeCard.buyModal.paying': '支払中...',
  'freeCard.buyModal.paySuccess': '支払成功',
  'freeCard.card.name': '無料カード-{name}',
  'freeCard.card.sellEndDate': '販売終了：{date}',
  'freeCard.card.cardId': 'カードID：{id}',
  'freeCard.card.freeDate': '無料日',
  'freeCard.card.freeTimeSlot': '無料時間：{slot}',
  'freeCard.card.remaining': '残り{remaining}/{total}',
  'freeCard.card.price': '￥{price}',
  'freeCard.card.yuan': '元',
  'freeCard.status.purchased': '購入済み',
  'freeCard.status.pending': '販売待ち',
  'freeCard.status.ended': '終了',
  'freeCard.status.cancelled': 'キャンセル',
  'freeCard.detail.purchaseTimeLeft': '残り時間',
  'freeCard.detail.days': '日',
  'freeCard.detail.hours': '時',
  'freeCard.detail.minutes': '分',
  'freeCard.detail.seconds': '秒',
  'freeCard.detail.validTimeLeft': '有効期限まで',
  'freeCard.detail.usageInstructions': '使用方法',
  'freeCard.empty': 'データなし',
  'freeCard.channelDetailTitle': 'カード詳細',
  'freeCard.card.city': '適用都市',
  'freeCard.card.timeSlot': '無料時間帯',
  'freeCard.paySuccess.title': '購入成功',
  'freeCard.paySuccess.desc': 'カードを購入しました',
  'freeCard.paySuccess.tips': '有効期限内にご使用ください',
  'freeCard.buyModal.selectPayMethod': '支払い方法を選択',
  'freeCard.buyModal.driverWallet': 'ドライバーウォレット',
  'freeCard.buyModal.wechatPay': 'WeChat支払い',
  'freeCard.buyModal.balance': '残高：¥{balance}',
  'freeCard.buyModal.insufficientWalletBalance': 'ウォレット残高不足',
  'freeCard.buyModal.checkingCondition': '購入条件を確認中...',
  'freeCard.buyModal.notEligible': '購入条件を満たしていません',
  'freeCard.driverInfo.title': 'ドライバー情報',
  'freeCard.driverInfo.name': 'ドライバー名',
  'freeCard.driverInfo.phone': '電話番号',
  'freeCard.driverInfo.vehicleNo': '車両ナンバー',
  'freeCard.driverInfo.switchAccount': 'アカウント切替',

  // 招待ページ
  'invite.pageTitle': 'ドライバー招待',
  'invite.recordTitle': '招待記録',
  'invite.viewDetail': '詳細表示',
  'invite.inviteCount': '招待人数',
  'invite.receivedReward': '獲得報酬',
  'invite.personUnit': '名',
  'invite.yuanUnit': '元',
  'invite.videoTip': '招待方法は？ビデオチュートリアルを見る',
  'invite.inviteNow': '今すぐ招待',

  // 招待記録ページ
  'inviteInfo.pageTitle': '招待記録',
  'inviteInfo.recordAndReward': '招待記録と報酬',
  'inviteInfo.noReward': '+ 0元',

  // 呼び込み注文ページ
  'beckonOrder.pageTitle': '呼び込み注文',
  'beckonOrder.status.idle': '待機中',
  'beckonOrder.status.boarded': '乗客乗車済み',
  'beckonOrder.status.completed': '乗客降車済み',
  'beckonOrder.label.driverInfo': 'ドライバー情報',
  'beckonOrder.label.onTime': '乗車時間',
  'beckonOrder.label.startAddress': '乗車地点',
  'beckonOrder.label.offTime': '降車時間',
  'beckonOrder.label.endAddress': '降車地点',
  'beckonOrder.placeholder.selectTime': '時間を選択',
  'beckonOrder.placeholder.searchAddress': '住所を検索',
  'beckonOrder.placeholder.notDropped': '未降車',
  'beckonOrder.placeholder.notLocated': '未特定',
  'beckonOrder.action.boarded': '乗客乗車済み',
  'beckonOrder.action.dropped': '乗客降車済み',
  'beckonOrder.action.newOrder': '新規注文',
  'beckonOrder.loading': '処理中...',
  'beckonOrder.success.boarded': '乗車情報を記録しました',
  'beckonOrder.success.completed': '注文完了',
  'beckonOrder.error.startAddressRequired': '乗車地点を入力してください',
  'beckonOrder.error.onTimeRequired': '乗車時間を選択してください',
  'beckonOrder.error.endAddressRequired': '降車地点を入力してください',
  'beckonOrder.error.endTimeRequired': '降車時間を選択してください',
  'beckonOrder.error.createFailed': '注文作成に失敗しました',
  'beckonOrder.error.completeFailed': '注文完了に失敗しました',
  'beckonOrder.error.locateFailed': '位置情報の取得に失敗しました',
  'beckonOrder.action.locate': 'タップして位置情報取得',
  'beckonOrder.locating': '位置情報取得中...',
  'beckonOrder.locateSuccess': '位置情報取得成功',

  // ホーム
  'home.beckonOrder': '呼び込み注文',
  'home.beckonOrderDesc': 'オフライン呼び込み注文',

}
